export default function getVariation(placement) {
  return placement.split('-')[1];
}


//////////////////
// WEBPACK FOOTER
// /Users/diego/DevKinsta/public/musicalgreasees/wp-content/themes/greasetema/node_modules/@popperjs/core/lib/utils/getVariation.js
// module id = 11
// module chunks = 0